import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Open TLS connections to the API and media CDN early, so the first data fetch
// after the shell paints doesn't also pay DNS + TLS setup cost. These domains
// are environment-specific (injected at build time), so we add the hints here
// rather than hardcoding them in index.html.
function preconnect(url) {
  if (!url) return
  try {
    const origin = new URL(url, window.location.href).origin
    for (const crossorigin of [false, true]) {
      const link = document.createElement('link')
      link.rel = 'preconnect'
      link.href = origin
      if (crossorigin) link.crossOrigin = 'anonymous'
      document.head.appendChild(link)
    }
  } catch {
    /* ignore malformed URLs */
  }
}
preconnect(import.meta.env.VITE_API_URL)
preconnect(import.meta.env.VITE_MEDIA_URL)

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
